import Sidebar from '@/components/Home_Sidebar/sidebarView.vue';
import Navbar from '@/components/Home_Navbar/NavbarView.vue';
import { get_user_details } from '@/router/index.js';

const admin_sections = [
  {
    title: 'Account',
    items: [
      {
        label: 'My Profile',
        subtitle: 'Identity, contact details and security',
        icon: 'fa-regular fa-user',
        class: 'admin-menu-icon-primary',
        target: { name: 'Profile' },
      },
    ],
  },
  {
    title: 'Administration',
    items: [
      {
        label: 'User Management',
        subtitle: 'Add, edit, and migrate users',
        icon: 'fa-solid fa-users',
          class: 'admin-menu-icon-primary',
        target: { name: 'Settings' },
      },
      {
        label: 'Roles & Permissions',
        subtitle: 'Define roles and access scopes',
        icon: 'fa-solid fa-layer-group',
        class: 'admin-menu-icon-dark',
        target: { name: 'Role' },
      },
      {
        label: 'Permission Library',
        subtitle: 'Manage feature-level access controls',
        icon: 'fa-solid fa-key',
        class: 'admin-menu-icon-muted',
        target: { name: 'Permission' },
      },
    ],
  },
  {
    title: 'Governance',
    items: [
      {
        label: 'Brand & Platform',
        subtitle: 'Configuration and launch governance',
        icon: 'fa-solid fa-sliders',
        class: 'admin-menu-icon-dark',
        target: { name: 'SystemConfigure' },
      },
    ],
  },
];

export default {
  name: 'MainSettings',
  components: {
    Sidebar,
    Navbar
  },
  data: () => ({
    user: get_user_details(),
    admin_sections,
  }),

  computed: {
    user_display_name() {
      const first = String(this.user?.first_name || '').trim();
      const last = String(this.user?.last_name || '').trim();
      return `${first} ${last}`.trim() || 'User';
    },
    user_email() {
      return this.user?.email || 'No email available';
    },
    user_role_label() {
      return this.user?.role || 'Admin';
    },
    user_initials() {
      const first = String(this.user?.first_name || '').trim();
      const last = String(this.user?.last_name || '').trim();
      const initials = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
      return initials || 'U';
    },
    show_company_warning() {
      return this.is_organization_user && this.has_no_company;
    },

    is_organization_user() {
      const role = String(this.user?.role || '').toLowerCase();
      const client_type = String(this.user?.client_type || '').toLowerCase();

      return role.includes('organization') || client_type === 'organization';
    },

    has_no_company() {
      return !this.user?.company_id;
    },
  },
  methods: {
    go_to_admin_target(target) {
      this.$router.push(target);
    },
    go_to_profile() {
      this.$router.push({ name: 'Profile' });
    },
  },
};
